export default __webpack_public_path__ + "static/bg-112665996a66276d7493257c32c56049.png";